import React, { useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import CurrencyInput from 'react-currency-input-field';
import { Modal, Table } from 'react-bootstrap';
import { CalculatorServices } from '../../services';
import "react-datepicker/dist/react-datepicker.css";
import './style.css';
import br from 'date-fns/locale/pt-BR'

registerLocale('br', br);

function Calculator({ hideTextInfo }) {
  const [amount, setAmount] = useState(0);
  const [installments, setInstallments] = useState(null);
  const [preferenceDay, setPreferenceDay] = useState(null);
  const [depositDate, setDepositDate] = useState(null);
  const [error, setError] = useState(false);
  const [calculatorDetails, setCalculatorDetails] = useState(null);
  const [showModal, setShowModal] = useState(false);


  function handleChangeAmount(value) {
    const newAmount = value ? Number(value.replace(',', '.')) : 0
    setAmount(newAmount);
  }

  function handleChangeInstallments(e) {
    setInstallments(Number(e.target.value));
  }

  function handleChangePreferenceDay(e) {
    setPreferenceDay(Number(e.target.value));
  }

  async function handleSubmit() {
    if((!amount || amount === 0) || !installments || !preferenceDay || !depositDate) {
      return setError(true);
    }
    setError(false);
    const payload = {
      amount,
      installments,
      preferenceDay,
      depositDate: depositDate.toISOString().split('T')[0].split('-').reverse().join('/'),
    }

    try {
      const response = await CalculatorServices.calculate(payload);
      setCalculatorDetails(response.data);
      setShowModal(true);
    } catch (error) {
      console.log(error);
    }
  }

  function formatCurrencyValue(value) {
    if(value < 0) return 'R$ 0,00';
    return value.toLocaleString('pt-br',{ style: 'currency', currency: 'BRL' });
  }
  return (
    <>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        aria-labelledby="example-custom-modal-styling-title"
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            Simulação de empréstimo
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Table striped bordered hover>
            <thead>
              <tr>
                <th>Valor do Empréstimo</th>
                <th>Número de parcelas</th>
                <th>Dia fixo de pagamento</th>
                <th>Data da Liberação</th>
                <th>Vencimento Inicial</th>
                <th>Vencimento Final</th>
                <th>Carência Inicial</th>
              </tr>
            </thead>
            {!!calculatorDetails?.valorEmprestimoTotal && (
              <tbody>
                <tr>
                  <td>{formatCurrencyValue(calculatorDetails.valorEmprestimo)}</td>
                  <td>{calculatorDetails.parcelas}</td>
                  <td>{calculatorDetails.diaEscolhido}</td>
                  <td>{calculatorDetails.dataDeposito}</td>
                  <td>{calculatorDetails.arrayParcelas[0].dataPagamento}</td>
                  <td>{calculatorDetails.arrayParcelas[calculatorDetails.arrayParcelas.length - 1].dataPagamento}</td>
                  <td>{calculatorDetails.carenciaInicial} dias</td>
                </tr>
              </tbody>
            )}
          </Table>
          <br></br><br></br>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Parcela</th>
                <th>Saldo Anterior</th>
                <th>Valor Parcela</th>
                <th>Juros</th>
                <th>Prestação</th>
                <th>Novo Saldo</th>
                <th>Data</th>
              </tr>
            </thead>
            {!!calculatorDetails?.valorEmprestimoTotal && (
              <tbody>
                {!!calculatorDetails.dadosValorInicialDevedor && (
                  <tr>
                    <td> - </td>
                    <td>{formatCurrencyValue(calculatorDetails.dadosValorInicialDevedor.saldoAnterior)}</td>
                    <td> - </td>
                    <td>{formatCurrencyValue(calculatorDetails.dadosValorInicialDevedor.jurosInicial)}</td>
                    <td> - </td>
                    <td>{formatCurrencyValue(calculatorDetails.dadosValorInicialDevedor.novoSaldo)}</td>
                    <td>{calculatorDetails.dadosValorInicialDevedor.data}</td>
                  </tr>
                )}
                {calculatorDetails.arrayParcelas.map((parcela, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{formatCurrencyValue(parcela.saldoAnterior)}</td>
                    <td>{formatCurrencyValue(parcela.valorDaParcela)}</td>
                    <td>{formatCurrencyValue(parcela.valorDoJuros)}</td>
                    <td>{formatCurrencyValue(parcela.valorFinalDaParcela)}</td>
                    <td>{formatCurrencyValue(parcela.valorEmprestimoRestante)}</td>
                    <td>{parcela.dataPagamento}</td>
                  </tr>
                ))}
              </tbody>
            )}
          </Table>
        </Modal.Body>
      </Modal>
      <div className="calculator-content">
        {!hideTextInfo && (<h2>Calculadora</h2>) }
        {!hideTextInfo && (<h4>Simule seu empréstimo em até 48x.</h4>)}
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <CurrencyInput 
            className="calculator-input"
            placeholder="Digite o valor do empréstimo"
            allowNegativeValue={false}
            prefix="R$"
            decimalSeparator=","
            groupSeparator="."
            maxLength="8"
            onValueChange={handleChangeAmount}
          />
          <select className="calculator-select" onChange={handleChangeInstallments}>
            <option value="" disabled selected>Selecione o número de parcelas</option>
            {Array.from(Array(48).keys()).map((_, index) => (
              <option key={index} value={index + 1}>{`${index + 1}x`}</option>
            ))}
          </select>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <select className="calculator-select" onChange={handleChangePreferenceDay}>
            <option value="" disabled selected>Escolha o dia de pagamento</option>
            <option value={15}>Quinzena (dias 15 do mês)</option>
            <option value={30}>Final do mês (dias 30 do mês)</option>
          </select>
          <DatePicker
            wrapperClassName="datePicker"
            locale="br"
            dateFormat="dd/MM/yyyy"
            minDate={new Date()}
            selected={depositDate}
            onChange={(date) => setDepositDate(date)}
            placeholderText="Selecione o dia do depósito"
            strictParsing
          />
        </div>
        {error && (
          <p
            style={{ fontSize: '12px', color: '#e74c3c', marginLeft: '2px', fontWeight: 'bold' }}
          >
            Preencha todos os campos para efetuar o cálculo.
          </p>
        )}
        <button className="calculator-submit" onClick={handleSubmit}>
          Calcular
        </button>
      </div>
    </>
  )
}

export default Calculator;